import type {
  SamplingValues,
  DateUnity,
  OperatorsValues,
  TableColumn,
} from "@/types";
import env from "../../env.json";

export const HOSTS: any = {
  AWS: process.env.PUBLIC_APP_HOSTS_AWS,
  WSS: process.env.PUBLIC_APP_HOSTS_WSS,
};
export const ENDPOINTS: any = env.ENDPOINTS;

export const DEFAULT_TZ = "Europe/Paris";

export const FILES_ACCEPTED_LIST =
  ".csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const VARIABLE_TYPE = "variable";
export const FORMULA_TYPE = "formula";
export const PERSISTED_FORMULA = "persisted_formula";
export const MANUAL_VARIABLE = "manual_variable";
export const TABLEAU_TYPE = "tableau";
export const BAR_PLOT_TYPE = "bar-plot";
export const SPLINE = "spline";
export const AREA = "area";
export const AREA_SPLINE = "areaspline";
export const BULLET = "bullet";
export const TIME_SERIES = "time-series";

export const COLUMN = "column";
export const GAUGE = "gauge";
export const STATUS_NEW = "new";
export const STATUS_SEEN = "seen";
export const STATUS_FIXED_NO_ACTION = "fixed_no_action";
export const STATUS_FIXED = "fixed";
export const COM_NO_DATA_LABEL = ["com", "nodata", "offline"];

export const DOWNLOADREQUEST = "download_request";
export const VALIDATEMANUALDATAFILE = "validate_manual_data";
export const UPLOADMANUALDATA = "upload_manual_data";
export const DOWNLOADMANUALDATA = "download_manual_data";
export const MULTIVARIATEREGRESSION = "multivariate_regression";
export const MAINTENANCE_LABEL = "error.MAINTENANCE";
export const VARIABLE_NOT_FOUND = "error.VARIABLE_NOT_FOUND";
export const UNAUTHORIZED = "UNAUTHORIZED";
export const PERMISSIONS = {
  ALERTING_MANAGE: "alerting_configuration_manage",
  ALERTING_VIEW: "alerting_configuration_view",
  ALERTING_SCENARIO_VIEW: "alerting_scenario_view",
  ALERTING_SCENARIO_MANAGE: "alerting_scenario_manage",
  ALERTING_EVENTS_VIEW: "alerting_event_view",
  ALERTING_EVENTS_MANAGE: "alerting_event_manage",
  USER_ROLE_VIEW: "user_view",
  USER_ROLE_MANAGE: "user_manage",
  PERMISSION_ROLE_VIEW: "permission_role_view",
  PERMISSION_ROLE_MANAGE: "permission_manage",
  DATA_EXPLORER_MANAGE: "data_explorer_manage",
  DATA_EXPLORER_VIEW: "data_explorer_view",
  SELF_SERVICE_MANAGE: "self_service_manage",
  SELF_SERVICE_VIEW: "self_service_view",
  VARIABLE_IMPORT_MANAGE: "variable_import_manage",
  VARIABLE_IMPORT_VIEW: "variable_import_view",
  VARIABLE_PROJECT_MANAGE: "variable_project_manage",
  VARIABLE_VIEW: "variable_configuration_view",
  VARIABLE_VIEW_PAGE: "variable_configuration_view_page",
  CONTACT_CONFIGURATION_MANAGE: "contact_manage",
  CONTACT_CONFIGURATION_VIEW: "contact_view",
  DATA_ANALYTIC_MANAGE: "data_analytic_manage",
  DATA_ANALYTIC_VIEW: "data_analytic_view",
  VARIABLE_MANAGE: "variable_configuration_manage",
  CLIENT_CONFIGURATION_MANAGE: "client_manage",
  CLIENT_VIEW: "client_view",
  HISTORY_VIEW: "history_view",
  PROJECT_CONFIGURATION_MANAGE: "project_manage",
  PERSONALIZED_REPORTING_MANAGE: "personalized_report_manage",
  PERSONALIZED_REPORTING_VIEW: "personalized_report_view",
  MAINTENANCE_REPORTING_MANAGE: "maintenance_report_manage",
  MAINTENANCE_REPORTING_VIEW: "maintenance_report_view",
  CPE_REPORTING_MANAGE: "cpe_report_manage",
  CPE_REPORTING_VIEW: "cpe_report_view",
  INTERVENTION_MANAGE: "intervention_manage",
  INTERVENTION_VIEW: "intervention_view",
  UNIT_CONFIGURATION_MANAGE: "unit_configuration_manage",
  SYNOPTIC_VIEW: "synoptic_view",
  SYNOPTIC_MANAGE: "synoptic_manage",
  SYNOPTIC_MANAGE_ORDER: "synoptic_manage",
  USER_READER: "user_reader",
  ENERGY_SAVING_VIEW: "energy_saving_view",
  PLACE_VIEW: "place_view",
  PLACE_MANAGE: "place_manage",
  PROJECT_PARAM_VIEW: "project_in_parameters_view",
  PROJECT_PAGE_VIEW: "project_in_projects_view",
  HOME_PAGE_VIEW: "home_page_view",
};

export const AGGREGATIONS: any[] = [
  {
    id: "3dfb5045-cf86-462c-80c3-1c7dec283f75",
    name: "average",
  },
  { id: "f89a4916-1ef5-4c7a-8966-fff1f02487f8", name: "min" },
  { id: "997bc938-d3f8-48fe-a340-762648982fd0", name: "max" },
  { id: "e5598126-c7ac-412c-bc67-6c275ca22982", name: "sum" },
  {
    id: "a7b4561c-3efa-449c-9567-d71b7838f499",
    name: "counter",
  },
];

export const AVATAR_URL = "https://eu.ui-avatars.com/api";

export const CERTINERGY_EMAIL = "certinergy-engie.com";
export const CNSOLUTIONS_EMAIL = "cnsolutions.fr";
export const EMAIL_REGX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@(cnsolutions.fr|certinergy-engie.com)$/;

export const SCATTER_PLOT_ID = "scatter-plot";
export const HISTOGRAMME = "histogram";
export const HEATMAP = "heatmap";
export const GRAPHE_TABLE = [
  {
    type: "ytd",
    value: 1000,
  },
  {
    type: "mtd",
    value: 2000,
  },
  {
    type: "current",
    value: 50,
  },
];

export const COLORS: string[] = [
  "#00bcfd",
  "#23d2b5",
  "#353a3d",
  "#1f106d",
  "#e74a50",
  "#f78a31",
  "#fbdb3c",
  "#6ed2b1",
];

export const SAMPLING_VALUES: SamplingValues[] = [
  { type: "seconds", value: 1 },
  { type: "minutes", value: 60 },
  { type: "hours", value: 3600 },
  { type: "days", value: 86400 },
  { type: "weeks", value: 604800 },
  { type: "months", value: 30.4167 * 86400 },
  { type: "years", value: 365 * 86400 },
];

export const SAMPLING_UNIT: DateUnity[] = [
  { value: "seconds", label: "Seconds" },
  { value: "minutes", label: "Minutes" },
  { value: "hours", label: "Hours" },
  { value: "days", label: "Days" },
  { value: "weeks", label: "Weeks" },
  { value: "months", label: "Months" },
  { value: "years", label: "Years" },
];

export const DAYS_OPTIONS: string[] = [
  "Lundi",
  "Mardi",
  "Mercredi",
  "Jeudi",
  "Vendredi",
  "Samedi",
  "Dimanche",
];

export const MATHS_OPERATORS: OperatorsValues[] = [
  { label: "SI", value: "where", level: 0 },
  { label: "ABS", value: "abs", level: 0 },
  { label: "AND", value: "&", level: 0 },
  { label: "OR", value: "|", level: 0 },
  { label: "NOT", value: "~", level: 0 },
  { label: "<=", value: "<=", level: 0 },
  { label: ">=", value: ">=", level: 0 },
  { label: "==", value: "==", level: 0 },
  { label: "!=", value: "!=", level: 0 },
  { label: "<", value: "<", level: 0 },
  { label: ">", value: ">", level: 0 },
  { label: "-", value: "-", level: 1 },
  { label: "+", value: "+", level: 1 },
  { label: "*", value: "*", level: 1 },
  { label: "/", value: "/", level: 1 },
  { label: "^", value: "**", level: 1 },
  { label: "(", value: "(", level: 1 },
  { label: ")", value: ")", level: 1 },
  { label: ",", value: ",", level: 1 },
];

export const EVENT_LIST_COLUMNS: TableColumn[] = [
  { value: "client", label: "events.client" },
  { value: "place", label: "events.place" },
  { value: "project", label: "events.project" },
  { value: "alertName", label: "events.alertName" },
  { value: "variableName", label: "alerting.variable" },
  { value: "sourceTechnicalName", label: "selfData.form.sourceId" },
  { value: "alertLevelName", label: "events.criticality" },
  { value: "dateStart", label: "events.dateStart" },
  { value: "dateEnd", label: "events.dateEnd" },
  { value: "duration", label: "events.period" },
  { value: "status", label: "events.status" },
  { value: "type", label: "alerting.type" },
];

export const DEFAULT_EVENT_LIST_COLUMNS: string[] = [
  "place",
  "project",
  "alertName",
  "variableName",
  "sourceTechnicalName",
  "status",
  "type",
  "dateStart",
  "dateEnd",
];

export const BEXTICKET_LIST_COLUMNS: TableColumn[] = [
  { value: "project", label: "events.project" },
  { value: "date", label: "bexTicket.date" },
  { value: "type", label: "bexTicket.type" },
  { value: "user", label: "bexTicket.user" },
  { value: "title", label: "bexTicket.title" },
  { value: "statut", label: "bexTicket.statut" },
  { value: "duration", label: "bexTicket.duration" },
];

export const DEFAULT_BEXTICKET_LIST_COLUMNS: string[] = [
  "project",
  "date",
  "type",
  "user",
  "title",
  "statut",
  "type",
  "duration",
];

export const BEXRAPPORT_LIST_COLUMNS: TableColumn[] = [
  { value: "project", label: "events.project" },
  { value: "bsReportName", label: "bexRapport.name" },
  { value: "startDate", label: "bexRapport.dateStart" },
  { value: "endDate", label: "bexRapport.endDate" },
];

export const BEXRAPPORT_AUTO_LIST_COLUMNS: TableColumn[] = [
  { value: "project", label: "events.project" },
  { value: "frequency", label: "bexRapport.auto.frequency" },
  { value: "reportName", label: "bexRapport.name" },
  { value: "reportTitle", label: "bexRapport.title" },
  { value: "contactName", label: "alerting.contactName" },
];

export const BEXRAPPORT_AUTO_LIST_HISTORY_COLUMNS: TableColumn[] = [
  { value: "project", label: "events.project" },
  { value: "report.name", label: "bexRapport.name" },
  { value: "startDate", label: "bexRapport.dateStart" },
  { value: "endDate", label: "bexRapport.endDate" },
];

export const DEFAULT_BEXRAPPORT_LIST_COLUMNS: string[] = [
  "project",
  "bsReportName",
  "startDate",
  "endDate",
];
export const DEFAULT_BEXRAPPORT_AUTO_LIST_COLUMNS: string[] = [
  "project",
  "frequency",
  "reportName",
  "reportTitle",
  "contactName",
];

export const DEFAULT_BEXRAPPORT_AUTO_LIST_HISTORY_COLUMNS: string[] = [
  "project",
  "report.name",
  "startDate",
  "endDate",
];

export const HOME_LIST_COLUMNS: TableColumn[] = [
  { value: "client", label: "home.client" },
  { value: "site", label: "home.site" },
  { value: "project", label: "home.project" },
  { value: "global", label: "home.dataQuality" },
  { value: "offline", label: "home.offline" },
  { value: "nodata", label: "home.nodata" },
  { value: "com", label: "home.com" },
  { value: "spec", label: "home.business" },
  { value: "total", label: "home.total" },
  { value: "new", label: "home.new" },
  { value: "tech", label: "home.technical" },
  { value: "daysdelay", label: "home.daysdelay" },
];
export const DEFAULT_HOME_LIST_COLUMNS: string[] = [
  "client",
  "site",
  "project",
  "global",
  "offline",
  "nodata",
  "com",
  "spec",
  "total",
  "new",
  "tech",
  "daysdelay",
];

export const PROJECT_LIST_COLUMNS: TableColumn[] = [
  { value: "client", label: "home.client" },
  { value: "site", label: "home.site" },
  { value: "project", label: "home.project" },
  { value: "chrono_sf", label: "project.chrono_sf" },
  { value: "chef_projet", label: "project.chef_projet" },
  { value: "date_signature", label: "project.date_signature" },
  { value: "date_debut", label: "project.date_debut" },
  { value: "nombre_aape", label: "project.nombre_aape" },
  { value: "engagement_mwh", label: "project.engagement_mwh" },
  { value: "engagement_mwh_pcs", label: "project.engagement_mwh_pcs" },
];
export const DEFAULT_PROJECT_LIST_COLUMNS: string[] = [
  "client",
  "site",
  "project",
  "chrono_sf",
  "chef_projet",
  "date_signature",
  "date_debut",
  "nombre_aape",
  "engagement_mwh",
  "engagement_mwh_pcs",
];
export const ALERT_LIST_COLUMNS: TableColumn[] = [
  { value: "client", label: "alerting.client" },
  { value: "place", label: "alerting.place" },
  { value: "project", label: "alerting.project" },
  { value: "alertName", label: "alerting.name" },
  { value: "variableName", label: "alerting.variable" },
  { value: "sourceTechnicalName", label: "selfData.form.sourceId" },
  { value: "alertType", label: "alerting.type" },
  { value: "alertLevelName", label: "alerting.level" },
  { value: "scenarios", label: "alerting.scenario" },
  { value: "threshold", label: "alerting.threshold" },
  { value: "contactsName", label: "alerting.contactName" },
  { value: "contactsEmail", label: "alerting.contactEmail" },
];

export const ALERT_LIST_COLUMNS_COM: TableColumn[] = [
  { value: "client", label: "alerting.client" },
  { value: "place", label: "alerting.place" },
  { value: "project", label: "alerting.project" },
  { value: "alertName", label: "alerting.name" },
  { value: "alertType", label: "alerting.type" },
  { value: "alertLevelName", label: "alerting.level" },
  { value: "threshold", label: "alerting.threshold" },
  { value: "contactsName", label: "alerting.contactName" },
  { value: "contactsEmail", label: "alerting.contactEmail" },
];

export const DEFAULT_ALERT_LIST_COLUMNS: string[] = [
  "alertName",
  "variableName",
  "sourceTechnicalName",
  "alertType",
  "alertLevelName",
  "scenarios",
  "threshold",
  "contactsName",
  "contactsEmail",
];

export const DEFAULT_ALERT_LIST_COLUMNS_COM: string[] = [
  "alertName",
  "alertType",
  "alertLevelName",
  "threshold",
  "contactsName",
  "contactsEmail",
];

export const VARIABLES_LIST_COLUMNS: TableColumn[] = [
  { value: "variableName", label: "selfData.form.measureName" },
  { value: "unity", label: "selfData.form.unity" },
  { value: "acquisitionDevice", label: "selfData.form.boitier" },
  { value: "sourceTechnicalName", label: "selfData.form.sourceId" },
  { value: "variableType", label: "selfData.form.type" },
  { value: "aggregation", label: "selfData.form.aggregation_pref" },
  { value: "projects", label: "selfData.form.associatedProjects" },
];

export const DEFAULT_VARIABLES_LIST_COLUMNS: string[] = [
  "variableName",
  "unity",
  "acquisitionDevice",
  "sourceTechnicalName",
  "variableType",
  "aggregation",
  "projects",
];

export const VARIABLES_LIST_COLUMNS_PROJECT: TableColumn[] = [
  { value: "client", label: "selfData.form.client" },
  { value: "place", label: "selfData.form.site" },
  { value: "project", label: "selfData.form.project" },
  { value: "variableName", label: "selfData.form.measureName" },
  { value: "unity", label: "selfData.form.unity" },
  { value: "acquisitionDevice", label: "selfData.form.boitier" },
  { value: "sourceTechnicalName", label: "selfData.form.sourceId" },
  { value: "variableType", label: "selfData.form.type" },
  { value: "aggregation", label: "selfData.form.aggregation_pref" },
];

export const DEFAULT_VARIABLES_LIST_COLUMNS_PROJECT: string[] = [
  "client",
  "place",
  "project",
  "variableName",
  "unity",
  "acquisitionDevice",
  "sourceTechnicalName",
  "variableType",
  "aggregation",
];

export const VARIABLES_HISTORY_LIST_COLUMNS_PROJECT: TableColumn[] = [
  { value: "variable_id", label: "selfData.form.measureName" },
  { value: "change_at", label: "selfData.history.dateChange" },
  { value: "operation", label: "selfData.history.action" },
  { value: "old_name", label: "selfData.history.oldName" },
  { value: "new_name", label: "selfData.history.newName" },
];

export const DEFAULT_VARIABLES_HISTORY_LIST_COLUMNS_PROJECT: string[] = [
  "variable_id",
  "change_at",
  "operation",
  "old_name",
  "new_name",
];

export const SELF_DATA_COLUMNS: TableColumn[] = [
  { value: "name", label: "selfData.form.measureName" },
  { value: "unity", label: "selfData.form.unity" },
  { value: "sourceTechnicalName", label: "selfData.form.sourceId" },
  { value: "type", label: "selfData.form.type" },
  { value: "aggregation", label: "selfData.form.aggregation" },
];

export const DEFAULT_SELF_DATA_COLUMNS: string[] = [
  "name",
  "unity",
  "sourceTechnicalName",
  "type",
  "aggregation",
];

export const DATA_COLUMNS_IMPORT: TableColumn[] = [
  { value: "client", label: "alerting.client" },
  { value: "place", label: "alerting.place" },
  { value: "name", label: "selfData.form.name" },
  { value: "status", label: "selfData.form.status" },
  { value: "createdAt", label: "selfData.form.createdAt" },
  { value: "lastStatusUpdate", label: "selfData.form.lastStatusUpdate" },
];

export const DEFAULT_DATA_COLUMNS_IMPORT: string[] = [
  "client",
  "place",
  "name",
  "status",
  "createdAt",
  "lastStatusUpdate",
];

export const CONTACTS_COLUMNS: TableColumn[] = [
  { value: "name", label: "parameters.contacts.name" },
  { value: "email", label: "parameters.contacts.email" },
  { value: "creator", label: "parameters.contacts.creator" },
  { value: "createdAt", label: "parameters.contacts.createdAt" },
];

export const DEFAULT_CONTACTS_COLUMNS: string[] = [
  "name",
  "email",
  "creator",
  "createdAt",
];
